import { markdownToPlainText, markdownToStyledHtml } from '@/lib/markdownExport';

export function sanitizeFilenameStem(value, fallback = 'advoq-output') {
  const cleaned = String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return cleaned || fallback;
}

export function resolveShareUrl(sharePayload, origin = '') {
  const explicit = String(sharePayload?.share_url || '').trim();
  if (explicit.startsWith('http://') || explicit.startsWith('https://')) return explicit;
  const path = String(sharePayload?.share_path || '').trim();
  if (!path) return '';
  if (!origin) return path;
  return `${origin.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
}

export function buildPlainTextExport({ title, content, sourceLabel = '' }) {
  const filename = `${sanitizeFilenameStem(title)}.txt`;
  const body = markdownToPlainText(content || '');
  const header = [title, sourceLabel].filter(Boolean).join('\n');
  return {
    filename,
    mimeType: 'text/plain;charset=utf-8',
    content: [header, body].filter(Boolean).join('\n\n').trim(),
  };
}

export function buildHtmlExport({ title, content, author = '', sourceLabel = '' }) {
  const filename = `${sanitizeFilenameStem(title)}.html`;
  return {
    filename,
    mimeType: 'text/html;charset=utf-8',
    content: markdownToStyledHtml(content || '', {
      title,
      author: [author, sourceLabel].filter(Boolean).join(' · '),
    }),
  };
}

export function triggerDownload({ filename, mimeType, content }) {
  if (typeof document === 'undefined') return;
  const blob = new Blob([content], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
